import React, { ChangeEvent, useEffect, useState } from 'react';
import Input from '../input/Input';

interface StepperInputProps {
  presetValue: number;
  onChange: (newValue: number) => void;
  setValid: (valid: boolean) => void;
  disabled?: boolean;
  viewMode?: boolean;
  min?: number;
}

export const StepperInput: React.FC<StepperInputProps> = ({
  presetValue,
  onChange,
  setValid,
  disabled = false,
  viewMode = false,
  min = 0,
}) => {
  const [value, setValue] = useState<number>(presetValue);

  useEffect(() => {
    onChange(value);
  }, [value]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const nextValue = parseFloat(e.target.value);

    if (Number.isNaN(nextValue)) {
      setValid(false);
    } else {
      setValid(true);
    }
    setValue(parseFloat(nextValue.toFixed(2)));
  };

  return (
    <div
      className="stepper-input"
      onMouseDown={(e) => {
        e.stopPropagation();
      }}>
      <Input
        wrapperDivClassName={`stepper-input__input-wrapper ${disabled ? 'disabled' : ''}`}
        className="stepper-input__input"
        fullWidth={false}
        type="number"
        value={value}
        onChange={handleInputChange}
        disabled={disabled}
        min={min}
      />
      <div className={`pdq-arrows-wrapper ${disabled ? 'disabled' : ''}`}>
        <div
          className={`up ${!viewMode && 'clickable'}`}
          onClick={(e) => {
            if (disabled) return;

            e.stopPropagation();

            if (Number.isNaN(value)) {
              setValue(1);
              return;
            }

            setValue(value + 1);
          }}>
          <img src="./assets/icons/arrow.svg" />
        </div>
        <div
          className={`down ${!viewMode && 'clickable'}`}
          onClick={(e) => {
            if (disabled) return;

            e.stopPropagation();
            if (Number.isNaN(value)) {
              setValue(min);
              return;
            }
            if (min !== undefined && value - 1 < min) {
              setValue(min);
              return;
            }

            setValue(value - 1);
          }}>
          <img src="./assets/icons/arrow.svg" />
        </div>
      </div>
    </div>
  );
};
